import React from 'react'

import Contracts from '../../../../../presentation/pages/contractors/contracts'

import { useFetchContracts } from '../../../../../presentation/hooks/fetch-contracts'
import { useMe } from '../../../../../presentation/contexts/me'

import { makeContractorsContracts } from '../../../../usecases/contracts/remote-contracts-factory'

import IContractedDoctor from '../../../../../presentation/interfaces/contracted-doctor'

const MakeContracts = () => {
  document.title = 'BuscarMédicos - Contratos'

  const { me } = useMe()

  const { contracts } = useFetchContracts<IContractedDoctor>(
    makeContractorsContracts(me?.id as number),
  )

  const contractedDoctors = contracts.map((doctor) => ({
    ...doctor,
    linkProfile: `/contractors/doctor/${doctor.doctorId}`,
  }))

  return <Contracts contractedDoctors={contractedDoctors} />
}

export default MakeContracts
